import store from '@/core/store'
import {
  getUserBoxes,
  changeBoxAlias, moveBoxToAnotherLabel,
  archiveBoxForUser,
} from '@/app-domains/boxes/boxes.api'
import { addBoxes, editBoxLabels, setBoxAlias, setUnopenedCount, toggleArchivedBox, setSelectedBoxesForEditing } from '@/core/store/Slices/BoxesSlice'
import containersService from '@/services/containers.service'

class BoxesService {
  async getUserBoxes () {
    const boxes = await getUserBoxes()
    if (boxes.serializedResults) this.storeBoxes(boxes.serializedResults)
    containersService.generateContainersMap()
    store.commit('CONTAINERS:UPDATED')
  }

  getBoxesForLabel (labelId, archived = false) {
    const boxes = store.getState().boxes.boxes
    return Object.values(boxes).filter(
      (box) => box.boxlabels.find((boxlabel) => boxlabel.composedid === labelId) && box.archived === archived
    ).map(box => box.composedid)
  }

  getRawBoxesForLabel (labelId) {
    const boxes = store.getState().boxes.boxes
    return Object.values(boxes).filter(
      (box) => box.boxlabels.find((boxlabel) => boxlabel.composedid === labelId)
    )
  }

  changeBoxName ({ box, boxAlias }) {
    return new Promise((resolve, reject) => {
      changeBoxAlias({ boxId: box.composedid, boxAlias })
        .then(() => {
          store.dispatch(
            setBoxAlias({
              boxComposedId: box.composedid,
              boxId: box.id,
              boxAlias: boxAlias,
            })
          )
          containersService.generateContainersMap()
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  saveSelectedBoxes (selectedBoxes) {
    /*
    const noDuplicated = []
    for (const box of selectedBoxes) {
      if (!noDuplicated.find((_box) => _box.id === box.id)) {
        noDuplicated.push(box)
      }
    }
    */
    store.dispatch(setSelectedBoxesForEditing(selectedBoxes))
    store.commit('SELECTED_BOXES:UPDATED')
  }

  getSelectedBoxesFromStore () {
    return store.getState().boxes.selectedBoxes
  }

  async attachLabelsToBox (box, labels) {
    const parsedLabelIds = Array.isArray(labels) ? labels.map(label => label.composedid) : [labels.composedid]
    await moveBoxToAnotherLabel({ boxId: box.composedid, labelIds: parsedLabelIds })
    this.editBoxLabelsForBox(box, labels)
    containersService.generateContainersMap()
  }

  editBoxLabelsForBox (box, labels) {
    const parsedLabels = Array.isArray(labels) ? labels : [labels]
    store.dispatch(editBoxLabels({
      boxId: box.id,
      labels: parsedLabels
    }))
  }

  getUserBoxesFromStore () {
    return store.getState().boxes.boxes
  }

  findBoxbyId (boxId) {
    return Object.values(this.getUserBoxesFromStore()).find(box => box.composedid === boxId)
  }

  findBoxesByQuery (query) {
    const boxes = this.getUserBoxesFromStore()
    const boxesFiltered = Object.values(boxes)?.filter(box => box?.boxname?.includes(query) || box?.nickName?.includes(query))
    return boxesFiltered.length ? boxesFiltered : null
  }

  findBoxByName (boxName) {
    return Object.values(this.getUserBoxesFromStore()).find(box => box.boxname === boxName)
  }

  getAllStoredBoxes () {
    return Object.values(this.getUserBoxesFromStore())
  }

  storeBoxes (boxes) {
    store.dispatch(addBoxes(boxes))
  }

  decreaseUnopenedCountOfBoxBy (boxId, unopenedCount) {
    const boxes = this.getAllStoredBoxes()
    const box = boxes.filter((box) => box.composedid === boxId)[0]
    if (!box || box.messageunopen <= 0) return
    store.dispatch(setUnopenedCount({ boxId: box?.id, unopened: box?.msgunopen - unopenedCount }))
    containersService.generateContainersMap()
  }

  increaseUnopenedCountOfBoxBy (boxId, unopenedCount) {
    const boxes = this.getAllStoredBoxes()
    const box = boxes.filter((box) => box.composedid === boxId)[0]
    if (!box) return
    store.dispatch(setUnopenedCount({ boxId: box?.id, unopened: (box.msgunopen + unopenedCount) }))
  }

  async toggleArchivedBox (boxId) {
    store.dispatch(toggleArchivedBox({ boxId }))
    containersService.generateContainersMap()

    await archiveBoxForUser(boxId)
    containersService.generateContainersMap()
  }
}

export default new BoxesService()
